<template>
  <div>
    <div
      class="bg-neutral-white flex items-center border-primary-700 justify-center border-dashed border-2 w-full h-[114px] rounded-lg cursor-pointer"
      :class="[
        {
          'w-[114px]': length > 0,
          '!border-danger-700': error,
          'border-primary-800': dragging,
          'border-neutral-200': !dragging,
        },
        styleParent,
      ]"
      @dragover.prevent="dragging = true"
      @dragenter.prevent
      @dragleave="dragging = false"
      @drop.prevent="handleDrop"
      @click="handleClick"
    >
      <input
        ref="uploader"
        type="file"
        class="hidden"
        :accept="accept"
        :multiple="multiple"
        @change="handleFileChange"
      />

      <div class="text-center flex-col flex items-center select-none">
        <CloudArrowUpIcon class="h-8 w-8 text-primary-700 text-center" />
        <p class="text-sm text-typography-primary">{{ subText }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CloudArrowUpIcon } from '@heroicons/vue/24/outline';

const emit = defineEmits(['change']);

const dragging = ref(false);
const uploader = ref<HTMLInputElement | null>(null);
const props = defineProps({
  accept: {
    default: 'image/*',
    type: String,
  },
  error: {
    default: false,
    type: Boolean,
  },
  max: {
    default: 2,
    type: Number,
  },
  multiple: {
    default: false,
    type: Boolean,
  },
  styleParent: {
    default: '',
    type: String,
  },
  text: {
    default: '',
    type: String,
  },
});

const length = computed(() => {
  return modelFiles.value?.length || 0;
});

const modelFiles = defineModel<any>();
const subText = computed(() => {
  if (props.text) return props.text;

  if (!modelFiles.value?.length) {
    return 'Click to upload or drag and drop';
  }

  if (props.multiple) {
    return 'Add more';
  }
});

function handleDrop(event: any) {
  dragging.value = false;
  modelFiles.value = Array.from(event.dataTransfer.files);
  emit('change', Array.from(event.dataTransfer.files));
}

function handleClick() {
  uploader.value?.click();
}

const iterableFiles = computed(() => {
  if (!modelFiles.value?.length) {
    return [];
  }

  return Array.from(modelFiles.value);
});

function handleFileChange() {
  if (!uploader.value?.files) return;
  if (props.multiple && iterableFiles.value.length >= props.max) return;

  if (props.multiple) {
    const newFiles = Array.from(uploader.value.files);
    const remainingSlots = props.max - iterableFiles.value.length;
    const actualAddedFiles = newFiles.slice(0, remainingSlots);

    modelFiles.value = iterableFiles.value.concat(actualAddedFiles);
    if (actualAddedFiles.length > 0) emit('change', actualAddedFiles);

    return;
  }

  modelFiles.value = iterableFiles.value.concat([uploader.value.files[0]]);
  emit('change', [uploader.value.files[0]]);
}
</script>
